export default __webpack_public_path__ + "static/media/img_momin.58d0766a.png";